import { Aspect } from '@teambit/harmony';

export const JestAspect = Aspect.create({
  id: 'teambit.defender/jest',
});
